// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2271e6ee","453":"cee3c04c","732":"74db4990","977":"8fe118f6"}[chunkId] + ".chunk.js";
};